import { FC, VideoHTMLAttributes, useId, useRef, useState } from "react";

import { PlayArrowFilled } from "@livechat/design-system-icons";
import { DesignToken, Icon } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { playButtonStyles, videoControlsStyles, videoStyles, wrapperStyles } from "./styles";

const PlayerControls: FC<{ onTogglePlay: () => void; isPlaying: boolean; videoId: string }> = ({
  onTogglePlay,
  isPlaying,
  videoId,
}) => (
  <button
    css={videoControlsStyles}
    onClick={onTogglePlay}
    type="button"
    aria-controls={videoId}
    aria-label={isPlaying ? "Pause video" : "Play video"}
  >
    {!isPlaying && (
      <Icon
        source={PlayArrowFilled}
        size="large"
        customColor={withVar(DesignToken.ContentInvertPrimary)}
        css={playButtonStyles}
      />
    )}
  </button>
);

type IProps = {
  children: React.ReactNode;
  maxWidth?: string;
  withControls?: boolean;
} & Pick<VideoHTMLAttributes<HTMLVideoElement>, "poster" | "loop" | "autoPlay">;

export const VideoPlayer: FC<IProps> = ({
  children,
  withControls = false,
  poster,
  maxWidth = "800px",
  loop = true,
  autoPlay = false,
}) => {
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const ref = useRef<HTMLVideoElement>(null);
  const id = useId();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onTogglePlay = () => {
    if (ref.current) {
      if (isPlaying) {
        ref.current.pause();
      } else {
        ref.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div css={wrapperStyles(maxWidth)}>
      <video css={videoStyles(maxWidth)} muted loop={loop} ref={ref} poster={poster} autoPlay={autoPlay} id={id}>
        {children}
      </video>
      {withControls && <PlayerControls onTogglePlay={onTogglePlay} isPlaying={isPlaying} videoId={id} />}
    </div>
  );
};
